<script setup>
import { originalCountries } from '~/assets/jsons/originalParams.json';

const route = useRoute();
const { country } = route.params;
const localePath = useLocalePath();

const originalCountry = originalCountries[country];

const showContent = ref(false);

onMounted(() => {
  setTimeout(() => {
    showContent.value = true;
  }, 1000);
});
</script>

<template>
    <!-- Hero Section -->
    <section class="h-screen relative overflow-hidden w-full px-4">
      <div class="country-bg-image" :style="`background-image: url('/media/countries/${originalCountry}.webp')`"></div>
      <div class="h-screen container max-w-2xl flex flex-col items-center justify-center mx-auto gap-[10vh] relative z-20">
          <h1
            data-aos="fade-up"
            data-aos-delay="1000"
            data-aos-duration="1000"
            class="text-4xl md:text-5xl font-bold text-center text-white">
            {{ $t(`lawyerCountries.${originalCountry}.legalSystem`) }}</h1>
        
        <p
        data-aos="fade-up"
        data-aos-delay="1250"
        data-aos-duration="1000"
        class="text-center text-white">
          {{ $t(`lawyerCountries.${originalCountry}.accessComprehensiveLegalInfo`) }}
        </p>
        <div
        data-aos="fade-up"
        data-aos-delay="1500"
        data-aos-duration="1000"
        class="flex flex-wrap gap-4">
          <PrimeButton
            as="router-link"
            :to="localePath({ name: 'chat-profession', params: { profession: $t('routes.professions.lawyer') } })"
            :label="$t('pages.profession.startLegalConsultation')"
            icon="pi pi-comments"
            icon-pos="right"
            size="large"
            class="px-6 countryHeroButton"
          />
        </div>
      </div>
    </section>
</template>

<style scoped>
.country-bg-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 1;
}

.country-bg-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6); /* Koyu overlay */
  z-index: 2;
}

.countryHeroButton {
  box-shadow: 0 12px 24px var(--p-primary-500);
  transition: box-shadow 0.3s ease;
}

.countryHeroButton:hover {
  box-shadow: 0 16px 28px var(--p-primary-500);
}

</style>